import React from "react";
import { Badge } from "../../../components/ui/badge";
import type { DistributionSourceLabel } from "../types/distribution";

const SOURCE_LABEL: Record<DistributionSourceLabel, string> = {
  klassenfahrt: "Klassenfahrt",
  ausflug: "Ausflug",
  ausfall: "Ausfall",
  sonstiges: "Klassenabwesenheit",
  betreuung: "Betreuung",
  adhoc: "Adhoc-Stunde",
};

interface Props {
  sourceClassName?: string | null;
  sourceLabel?: DistributionSourceLabel | null;
}

export function DistributionSourceBadge({
  sourceClassName,
  sourceLabel,
}: Props) {
  if (!sourceClassName && !sourceLabel) {
    return (
      <Badge variant="outline" className="text-xs">
        Gast
      </Badge>
    );
  }

  const labelText = sourceLabel
    ? SOURCE_LABEL[sourceLabel] ?? sourceLabel
    : null;
  const fullText = [
    sourceClassName ? `Zugeteilt von ${sourceClassName}` : null,
    labelText,
  ]
    .filter(Boolean)
    .join(" · ");
  const compactText = sourceClassName ? `von ${sourceClassName}` : labelText!;

  return (
    <Badge
      variant="outline"
      className="text-xs border-amber-300 bg-amber-50 text-amber-900"
      title={fullText}
    >
      {compactText}
    </Badge>
  );
}
